export default import.meta.ROLLDOWN_FILE_URL_29erzbhPEsjZPpacW1i5Jg